import React from 'react';

function SupportNote() {
  return (
    <p className="mt-8 text-center text-base leading-normal text-retino-darkgrey sm:text-sm">
      {gettext('If you encounter any problems, please do not hesitate to contact our support at')}{' '}
      <a href="mailto:support@retino.com" className="font-semibold text-brand-500">
        support@retino.com
      </a>
      .
    </p>
  );
}

export default SupportNote;
